"use client";

import { c as _c } from "react/compiler-runtime";
import { Moon, Sun } from "@phosphor-icons/react";
import { useEffect, useState } from "react";
import { THEME_COOKIE, THEME_COOKIE_MAX_AGE } from "@/lib/brand/theme-choice";
function currentIsDark(): boolean {
  const attr = document.documentElement.getAttribute("data-theme");
  if (attr) return attr === "dark";
  return window.matchMedia?.("(prefers-color-scheme: dark)").matches ?? false;
}

// Both icons render; globals.css shows the right one from the theme on <html>,
// so first paint is correct with no hydration flash.
export function ThemeToggle(t0) {
  const $ = _c(11);
  const {
    initial,
    locale,
    size: t1
  } = t0;
  const size = t1 === undefined ? 22 : t1;
  const [dark, setDark] = useState(initial === "dark");
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setDark(currentIsDark());
    };
    t3 = [];
    $[0] = t2;
    $[1] = t3;
  } else {
    t2 = $[0];
    t3 = $[1];
  }
  useEffect(t2, t3);
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = function flip() {
      const next = !currentIsDark();
      document.documentElement.setAttribute("data-theme", next ? "dark" : "light");
      document.cookie = `${THEME_COOKIE}=${next ? "dark" : "light"}; path=/; max-age=${THEME_COOKIE_MAX_AGE}; SameSite=Lax`;
      setDark(next);
    };
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const flip = t4;
  const t5 = locale === "ar" ? "\u062A\u0628\u062F\u064A\u0644 \u0627\u0644\u0648\u0636\u0639 \u0627\u0644\u0641\u0627\u062A\u062D/\u0627\u0644\u062F\u0627\u0643\u0646" : "Switch light/dark mode";
  let t6;
  let t7;
  if ($[3] !== size) {
    t6 = <Moon size={size} className="theme-icon-light" aria-hidden={true} />;
    t7 = <Sun size={size} className="theme-icon-dark" aria-hidden={true} />;
    $[3] = size;
    $[4] = t6;
    $[5] = t7;
  } else {
    t6 = $[4];
    t7 = $[5];
  }
  let t8;
  if ($[6] !== dark || $[7] !== t5 || $[8] !== t6 || $[9] !== t7) {
    t8 = <button type="button" onClick={flip} aria-pressed={dark} className="inline-flex items-center justify-center w-10 h-10 rounded-lg text-foreground hover:text-primary hover:bg-accent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring" aria-label={t5}>{t6}{t7}</button>;
    $[6] = dark;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  return t8;
}